export default __webpack_public_path__ + "static/media/facebookIconCircle.38427b83.svg";